import { render, staticRenderFns } from "./SchoolSemesterDetail.vue?vue&type=template&id=31180b46&scoped=true"
import script from "./SchoolSemesterDetail.vue?vue&type=script&lang=js"
export * from "./SchoolSemesterDetail.vue?vue&type=script&lang=js"
import style0 from "./SchoolSemesterDetail.vue?vue&type=style&index=0&id=31180b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31180b46",
  null
  
)

export default component.exports